import React, { useEffect } from 'react';
import data from '../data.json';
import './MapCommon.css';
import { clearMapElements } from '../Map';

const MapCurrency: React.FC = () => {
    useEffect(() => {
        const svg = document.getElementById('world-map');
        if (svg) {
            clearMapElements();


            const paths = svg.getElementsByTagName('path');
            Array.from(paths).forEach(path => {
                const countryId = path.id.toUpperCase();
                const countryData = data.find(country => country.i.toUpperCase() === countryId);
                if (countryData && countryData.cu) {
                    const isEurope = countryData.o === 'Europe';
                    const fontSize = isEurope ? 10 : 18;

                    const symbol = countryData.cu.match(/\(([^)]+)\)/)?.[1] || countryData.cu;

                    const xPosition = path.getBBox().x + path.getBBox().width / 2;
                    const yPosition = path.getBBox().y + path.getBBox().height / 2;

                    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                    text.classList.add('currency');
                    text.setAttribute('x', xPosition.toString());
                    text.setAttribute('y', yPosition.toString());
                    text.setAttribute('text-anchor', 'middle');
                    text.setAttribute('font-size', fontSize.toString());
                    text.setAttribute('fill', 'red');
                    text.style.fontFamily = 'Inter, sans-serif';

                    text.textContent = symbol;

                    svg.appendChild(text);
                }
            });
        }
    }, []);

    return null;
};

export default MapCurrency;
